// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1w_4i","errorLogs":"EditorFooter_errorLogs__1f8OS"};